import { Button, styled, Typography } from '@mui/material'
import { closeCurrentModal } from 'weblite-web-modal-viewer'
import { SecondaryButton } from '$common/buttons'
import { BottomDrawer } from '$common/bottom-drawer'
import { sendEventToTwa } from '$logic/twaCommunication/twaCommunication.api'
import { TWA_EVENTS } from '$logic/twaCommunication'
import { registerNotification } from '$setup/notification'
import { isAndroidApp } from '$func/environmentInfo'
import { t } from '$i18n'
import { StartUpModalQueue } from '$func/startup-modal-handler'
import { setLastNotifPermissionRejectionTime } from '$setup/notification/permission'

const ButtonContainer = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 12px;
  width: 100%;
  background-color: ${({ theme }) => theme.palette.white};
  margin-top: auto;
  gap: 12px;
`

export function NotificationDialog({ isOpen }: { isOpen: boolean }) {
  return (
    <BottomDrawer
      isOpen={isOpen}
      onClose={() => {
        StartUpModalQueue.openNextModal()
        closeCurrentModal()
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          padding: '64px 16px',
          gap: '32px',
          alignItems: 'center',
        }}
      >
        <img
          src="assets/svg/notification-dialog.svg"
          width="240px"
          height="180px"
          alt=""
        />
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '16px',
            alignItems: 'center',
          }}
        >
          <Typography variant="h2">
            {t('permissionModal.notification.title')}
          </Typography>

          <Typography variant="paragraph1" textAlign="center">
            {t('permissionModal.notification.description')}
          </Typography>
        </div>
      </div>

      <ButtonContainer>
        <SecondaryButton
          fullWidth
          text={t('permissionModal.notification.activate')}
          onClick={() => {
            if (isAndroidApp)
              sendEventToTwa(
                TWA_EVENTS.CHECK_NOTIF_PERMISSION,
                undefined,
                300000,
              ).then(StartUpModalQueue.openNextModal.bind(StartUpModalQueue))
            else {
              registerNotification(
                StartUpModalQueue.openNextModal.bind(StartUpModalQueue),
              )
            }

            closeCurrentModal()
          }}
        />

        <Button
          fullWidth
          onClick={() => {
            setLastNotifPermissionRejectionTime()
            closeCurrentModal()
          }}
          variant="text"
          sx={{ color: 'neutral900' }}
        >
          {t('permissionModal.notYet')}
        </Button>
      </ButtonContainer>
    </BottomDrawer>
  )
}
